/**
 * Dynatrace
 *
 * @selector [data-dynatrace]
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

/**
 * enterAction
 * click PlatfromNav-company on page /privatpersonen
 * https://www.dynatrace.com/support/doc/javascriptapi/interfaces/dtrum_types.DtrumApi.html#enterAction
 *
 */
const DEFAULT_TRACKING = {
    enterAction: {
        actionName: 'generic',
        startTime: '',
        sourceUrl: '',
    },
};

export default class Dynatrace extends BaseModule {
    init(element) {
        this.el = element;
        this.$el = $(element);
        this.data = this.$el.data('dynatrace');

        this.bindListeners();

        return this;
    }

    bindListeners() {
        this.on('click', this.onClick);
    }

    onClick(e) {
        const { enterAction } = this.data;
        if (enterAction) {
            this.trackEnterAction(enterAction);
        }
        // implement more methods
    }

    trackEnterAction(enterAction) {
        const payload = {
            ...DEFAULT_TRACKING.enterAction,
            ...{ sourceUrl: location.href, startTime: Date.now(), ...enterAction },
        };
        console.log('Dtrum:enterAction', payload);

        try {
            /*
             *according to the ticket the api is exposed as window.dtrum
             * */
            // https://www.dynatrace.com/support/doc/javascriptapi/interfaces/dtrum_types.DtrumApi.html#enterAction
            window.dtrum.enterAction?.(payload.actionName, null, payload.startTime, payload.sourceUrl);
        } catch (e) {
            console.error('Dtrum:enterAction', e, payload);
        }
    }
}
